import { render, staticRenderFns } from "./goodsPurchaseReturn.vue?vue&type=template&id=daaeecbc&scoped=true"
import script from "./goodsPurchaseReturn.vue?vue&type=script&lang=js"
export * from "./goodsPurchaseReturn.vue?vue&type=script&lang=js"
import style0 from "./goodsPurchaseReturn.vue?vue&type=style&index=0&id=daaeecbc&prod&scoped=true&lang=css"
import style1 from "./goodsPurchaseReturn.vue?vue&type=style&index=1&id=daaeecbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaeecbc",
  null
  
)

export default component.exports